const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInitialWidgetIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.282,
    height: 20,
    viewBox: "0 0 19.282 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13810",
    d: "m110.859 183.816.537 1.067a.689.689 0 1 0 1.233-.613l-3.319-6.639a.482.482 0 0 0-.861 0l-3.319 6.639a.685.685 0 1 0 1.226.613l.537-1.067zm-2.121-3.7a.158.158 0 0 1 .275 0l1.157 2.321h-2.589z",
    transform: "translate(-105.056 -171.422)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13811",
    d: "M433.5 179.03a1.026 1.026 0 0 0-.73-1.756h-4.676a.689.689 0 1 0 0 1.377h3.519a.138.138 0 0 1 .1.227l-4.208 4.2a1.033 1.033 0 0 0 .73 1.763h4.676a.689.689 0 1 0 0-1.377h-3.241a.255.255 0 0 1-.179-.441z",
    transform: "translate(-414.521 -171.333)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13812",
    d: "M318.489 271.25a.689.689 0 1 0 0 1.377h2.2a.689.689 0 1 0 0-1.377z",
    transform: "translate(-309.428 -261.611)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13813",
    d: "M171.875 29.827a.689.689 0 0 0-.048-1.019 10.33 10.33 0 0 0-12.947-.448v-.689a.689.689 0 1 0-1.377 0v3.01a.358.358 0 0 0 .613.255l.379-.386a9.346 9.346 0 0 1 5.895-2.858 8.953 8.953 0 0 1 6.542 2.176.688.688 0 0 0 .943-.041z",
    transform: "translate(-155.439 -26.296)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13814",
    d: "m187.068 415.594-.358.358a9.312 9.312 0 0 1-5.805 2.755 8.912 8.912 0 0 1-6.515-2.114.719.719 0 1 0-.881 1.136 10.329 10.329 0 0 0 12.871.372v.689a.689.689 0 1 0 1.377 0l-.076-2.906a.358.358 0 0 0-.613-.289z",
    transform: "translate(-170.542 -400.17)",
    style: {
      fill: "#333"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitialWidgetIcon);
export default __webpack_public_path__ + "static/media/initial-widget-icon.3719c65c04980a6c557dae2d59cee5b7.svg";
export { ForwardRef as ReactComponent };